











import { Component, Mixins } from "vue-property-decorator";
import { instanceOfIWizardObjectDecoratable, IWizardInputDecoratable } from "../../../../../../domain/format";
import { AbstractTextItem } from "../../../../../../domain/document/items";
import { ObjectReferableContentMixin } from "./mixins";
import { FatalIndicator } from "./common";

@Component({
  components: {
    FatalIndicator,
  }
})
export default class WizardContentTextIndicator extends Mixins(ObjectReferableContentMixin) {
  get text(): string {
    return (this.item instanceof AbstractTextItem)
      ? this.item.text()
      : ""; 
  }

  get prefix(): string {
    return this.readDecoration(s => s.prefix);
  }

  get postfix(): string {
    return this.readDecoration(s => s.postfix);
  }

  private readDecoration(read: (s: IWizardInputDecoratable) => string): string {
    return (instanceOfIWizardObjectDecoratable(this.content) && !!read(this.content.decoration))
      ? read(this.content.decoration)
      : "";
  }
}
